import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
import { ARROW_ICONS } from 'constants/icons';
import { messages } from './ControlsMessages';
export function CarouselPrev(props) {
  var currentSlide = props.currentSlide,
      previousSlide = props.previousSlide;
  var isOnFirstSlide = currentSlide === 0;
  return React.createElement("a", {
    className: classNames('carousel__localnav carousel__localnav--prev', {
      'carousel__localnav--disabled': isOnFirstSlide
    }),
    onClick: previousSlide
  }, React.createElement(FormattedMessage, messages.previous), React.createElement(Isvg, {
    className: "svg",
    uniquifyIDs: false,
    src: ARROW_ICONS.arrow
  }));
}
CarouselPrev.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  previousSlide: PropTypes.func.isRequired
}; // eslint-disable-next-line react/no-multi-comp

export function CarouselNext(props) {
  var slidesToScroll = props.slidesToScroll,
      slideCount = props.slideCount,
      currentSlide = props.currentSlide,
      nextSlide = props.nextSlide,
      slidesToShow = props.slidesToShow;
  var isOnLastSlide = slidesToScroll + slidesToShow + currentSlide > slideCount;
  return React.createElement("a", {
    className: classNames('carousel__localnav carousel__localnav--next', {
      'carousel__localnav--disabled': isOnLastSlide
    }),
    onClick: nextSlide
  }, React.createElement(FormattedMessage, messages.next), React.createElement(Isvg, {
    className: "svg",
    uniquifyIDs: false,
    src: ARROW_ICONS.arrow
  }));
}
CarouselNext.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  nextSlide: PropTypes.func.isRequired,
  slidesToScroll: PropTypes.number.isRequired,
  slidesToShow: PropTypes.number.isRequired
}; // eslint-disable-next-line react/no-multi-comp

export var Pagination =
/*#__PURE__*/
function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _possibleConstructorReturn(this, _getPrototypeOf(Pagination).apply(this, arguments));
  }

  _createClass(Pagination, [{
    key: "getIndexes",
    value: function getIndexes(count, inc) {
      var arr = [];

      for (var page = 0; page < count; page += inc) {
        arr.push(page);
      }

      return arr;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          slideCount = _this$props.slideCount,
          slidesToScroll = _this$props.slidesToScroll,
          currentSlide = _this$props.currentSlide,
          goToSlide = _this$props.goToSlide;
      var indexes = this.getIndexes(slideCount, slidesToScroll);
      return React.createElement("ul", {
        className: "carousel__pagination"
      }, indexes.map(function (index) {
        return React.createElement("li", {
          key: index,
          className: classNames('carousel__pagination__page', {
            selected: currentSlide === index
          })
        }, React.createElement("a", {
          onClick: goToSlide.bind(null, index)
        }, index));
      }));
    }
  }]);

  return Pagination;
}(Component);
Pagination.propTypes = {
  slidesToScroll: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  currentSlide: PropTypes.number.isRequired,
  goToSlide: PropTypes.func.isRequired
};